export const getCarrierGroupHeaderStyle = (theme) => ({
    display: 'flex',
    overflow: 'auto',
    alignContent: 'flex-start',
    flexDirection: 'row',
    scrollbarGutter: 'stable both-edges',
    flexShrink: '0',
    textAlign: 'left',
    paddingLeft: '.75rem',
});